<template>
  <div>
    <h2 class="mt-6 mb-6">
      {{ machine.serial_number }}
      <br />
      {{ machine.name }}
    </h2>

    <v-card outlined class="pa-6 mb-6" style="background-color: transparent">
      <v-form @submit.prevent="getList(true)">
        <div class="row align-center">
          <div class="col-auto">
            <v-btn @click="setDate('month')" outlined color="blue" class="mr-3">本月</v-btn>
            <v-btn @click="setDate('today')" outlined color="blue">今日</v-btn>
          </div>
          <div class="col-12 col-md">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.from"
                  label="From"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.from" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>
          </div>
          <div class="col-12 col-md">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.to"
                  label="To"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.to" :min="form.from" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>
          </div>
          <div class="col-auto">
            <v-btn type="submit" color="blue">搜尋</v-btn>
          </div>
          <div class="col-auto">
            <v-btn @click="exportSaleRecords()" type="button" color="yellow" class="black--text">匯出</v-btn>
          </div>
        </div>
      </v-form>
    </v-card>

    <div class="row">
      <div class="col-12">
        <p class="title mb-0">{{ payment_stats.date_from }} ～ {{ payment_stats.date_to }}</p>
      </div>

      <div class="col-12 col-md-6">
        <v-card color="#333">
          <v-card-text>
            <v-list-item>
              <v-list-item-subtitle class="title">銷量</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ payment_stats.quantity }}</v-list-item-title>
            </v-list-item>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-12 col-md-6">
        <v-card color="#333">
          <v-card-text>
            <v-list-item>
              <v-list-item-subtitle class="title">總額</v-list-item-subtitle>
              <v-list-item-title class="headline">{{ payment_stats.total_amount }}</v-list-item-title>
            </v-list-item>
          </v-card-text>
        </v-card>
      </div>

      <div class="col-12">
        <v-card color="#333">
          <v-card-text>
            <div class="row">
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">現金</v-list-item-subtitle>
                    <v-list-item-title class="headline text-right">{{ payment_stats.cash_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">悠遊卡</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ payment_stats.easy_card_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">Linepay</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ payment_stats.linepay_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">iCash</v-list-item-subtitle>
                    <v-list-item-title class="headline text-right">{{ payment_stats.icash_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">信用卡</v-list-item-subtitle>
                    <v-list-item-title
                      class="headline text-right"
                    >{{ payment_stats.credit_card_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">一卡通</v-list-item-subtitle>
                    <v-list-item-title class="headline text-right">{{ payment_stats.ipass_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">街口支付</v-list-item-subtitle>
                    <v-list-item-title class="headline text-right">{{ payment_stats.jko_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
              <div class="col-6 col-md-3 pa-0">
                <v-list-item>
                  <div class="col-12 col-md-10 offset-md-1 px-0 px-md-3">
                    <v-list-item-subtitle class="title">其他</v-list-item-subtitle>
                    <v-list-item-title class="headline text-right">{{ payment_stats.other_amount }}</v-list-item-title>
                  </div>
                </v-list-item>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <h3 class="mt-6 mb-3">銷售紀錄</h3>

    <v-data-table
      :headers="thead"
      :items="sale_records"
      :items-per-page.sync="pagination.items"
      :page.sync="pagination.page"
      :footer-props="{
        'items-per-page-options': [50, 100, 200, 300, 500]
      }"
      :server-items-length="pagination.total"
    >
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>
    </v-data-table>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import PaginationMixin from "@/mixins/Pagination";

import machineApi from "@/api/machine";

export default {
  components: {},

  mixins: [PaginationMixin],

  props: ["id"],
  data() {
    return {
      machine: {},
      payment_stats: {},
      sale_records: [],
      machine_type: '',

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "銷售編號",
          value: "transaction_id",
          align: "center"
        },
        {
          text: "支付方式",
          value: "payment_method",
          align: "center"
        },
        {
          text: "卡片類型",
          value: "card_type",
          align: "center"
        },
        {
          text: "數量",
          value: "quantity",
          align: "right"
        },
        {
          text: "金額",
          value: "price",
          align: "right"
        },
        {
          text: "外部銷售編號",
          value: "external_transaction_id",
          align: "center"
        },
        {
          text: "銷售狀態",
          value: "transaction_status",
          align: "center"
        },
        {
          text: "銷售時間",
          value: "transaction_time",
          align: "center",
          width: "120px"
        },
        {
          text: "特店代號",
          value: "merchant_id",
          align: "center"
        },
        {
          text: "卡號",
          value: "card_number",
          align: "center"
        },
        {
          text: "授權碼",
          value: "approval_number",
          align: "center"
        }
      ],

      form: {
        from: "",
        to: ""
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    getList(shouldPaginationReset) {
      this.paginationInProgress = true;

      if (shouldPaginationReset) {
        this.resetPagination();
      }

      machineApi
        .getSaleRecords(
          this.id,
          this.form.from.replace(/-/g, ""),
          this.form.to.replace(/-/g, ""),
          this.pagination.items,
          this.pagination.page,
          this.machine_type
        )
        .then(res => {
          this.machine = res.machine;
          this.payment_stats = res.payment_stats;
          this.sale_records = res.sale_records;

          this.sale_records.forEach((item, idx) => {
            item.no =
              idx + 1 + this.pagination.items * (this.pagination.page - 1);
          });

          this.pagination.total = res.number_of_records;

          this.paginationInProgress = false;
        })
        .catch(err => {});
    },

    setDate(type) {
      switch (type) {
        case "month":
          const currentYear = new Date().toLocaleString("sv-SE").slice(0, 4);
          const currentMonth = new Date().toLocaleString("sv-SE").slice(5, 7);
          const days = new Date(currentYear, currentMonth, 0).getDate();

          this.form.from = `${currentYear}-${currentMonth}-01`;
          this.form.to = `${currentYear}-${currentMonth}-${days}`;
          break;
        case "today":
          this.form.from = new Date().toLocaleString("sv-SE").slice(0, 10);
          this.form.to = new Date().toLocaleString("sv-SE").slice(0, 10);
          break;
      }
    },

    exportSaleRecords() {
      machineApi
        .exportSaleRecords(
          this.id,
          this.form.from.replace(/-/g, ""),
          this.form.to.replace(/-/g, "")
        )
        .then(res => {
          this.download(
            res,
            this.form.from.replace(/-/g, ""),
            this.form.to.replace(/-/g, "")
          );
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.setDate("month");
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
</style>
